<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  useSeoMeta({
    titleTemplate: "%s | Zimmer Hotel Bosphorus"
  })
</script>
